/**
 * @generated SignedSource<<f7f3759f37d45be6729bc5783eacbf2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateSectionNotes_section$data = {
  readonly id: string;
  readonly notes: string;
  readonly " $fragmentType": "UpdateSectionNotes_section";
};
export type UpdateSectionNotes_section$key = {
  readonly " $data"?: UpdateSectionNotes_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateSectionNotes_section">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateSectionNotes_section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    }
  ],
  "type": "SongSection",
  "abstractKey": null
};

(node as any).hash = "74e64d3744be6e344a11a3d0b0002bf6";

export default node;
